import HomePage from "@/views/HomePage/HomePage";
import AppMapPage from "@/views/AppPage/AppMapPage";
import HGSSMapPage from "@/views/AppPage/HGSSMapPage";
import HPSMapPage from "@/views/AppPage/HPSMapPage";
import RegUserMapMapge from "@/views/AppPage/RegUserMapPage";
import ProfilePage from "@/views/ProfilePage/ProfilePage";
import UsersPage from "@/views/UsersPage/UsersPage";
import CommentsPage from "@/views/Komentari/CommentsPage";

import ZemljovidiPage from "@/views/ZemljovidiPage/ZemljovidiPage";
import POIPage from "@/views/GIS/POIPage/POIPage";
import StazePage from "@/views/GIS/StazePage/StazePage";
import ReportsPage from "@/views/ReportsPage/ReportsPage";
import RouteStatsPage from "@/views/RouteStatsPage/RouteStatsPage"
import RoutingSupportPage from "@/views/RoutingSupportPage/RoutingSupportPage";
import SigurnosnePorukePage from "@/views/SigurnosnePorukePage/SigurnosnePorukePage";
import SigurnosnaPodrucjaPage from "@/views/SigurnosnaPodrucjaPage/SigurnosnaPodrucjaPage"
import POIFormPage from "@/views/GIS/POIPage/POIFormPage";
import ObilaznicePage from "@/views/ObilaznicePage/ObilaznicePage";
import PlaninarskeUdrugePage from "@/views/PlaninarskeUdrugePage/PlaninarskeUdrugePage";
import MyIzletiPage from "@/views/Izleti/MyIzletiPage"
import VodicIzletiPage from "@/views/Izleti/VodicIzletiPage";
import UdrugaIzletiPage from "@/views/Izleti/UdrugaIzletiPage";
import UdrugaVodiciPage from "@/views/Vodici/UdrugaVodiciPage";
import SPVIzletiPage from "@/views/Izleti/SPVIzletiPage";
import SPVVodiciPage from "@/views/Vodici/SPVVodiciPage";
import HPSIzletiPage from "@/views/Izleti/HPSIzletiPage";
import HPSVodiciPage from "@/views/Vodici/HPSVodiciPage";
import RegisteredUserIzletiPage from "@/views/Izleti/RegisteredUserIzletiPage";
import HpsStatistikaPage from "@/views/Izleti/HpsStatistikaPage";

// Types
import { RouteType } from "@/@types/common";

const privateRoutes: RouteType[] = [
  { path: "/hgss/profile", name: "Profile", component: ProfilePage, style:'hgss'},
  { path: "/hgss/map", name: "Map", component: HGSSMapPage, style:'hgss'},
	{ path: "/hgss/users", name: "Map", component: UsersPage, style:'hgss'},
  { path: "/hgss/zemljovidi", name: "Zemljovdi", component: ZemljovidiPage, style:'hgss'},
  { path: "/hgss/poi", name: "POI", component: POIPage, style:'hgss'},
  { path: "/hgss/staze", name: "Staze", component: StazePage, style:'hgss'},
  { path: "/hgss/komentari", name: "Komentari", component: CommentsPage, style:'hgss'},
  { path: "/hgss/reporting", name: "Izvještaji", component: ReportsPage, style:'hgss'},
  { path: "/hgss/route-stats", name: "Statitstike o rutiranju", component: RouteStatsPage, style:'hgss'},
  { path: "/hgss/korekcijski-faktori", name: "Korekcijski faktori", component: RoutingSupportPage, style:'hgss'},
  { path: "/hgss/sigurnosne-poruke", name: "Sigurnosne poruke", component: SigurnosnePorukePage, style:'hgss'},
  { path: "/hgss/sigurnosna-podrucja", name: "Sigurnosna podrucja", component: SigurnosnaPodrucjaPage, style:'hgss'},
  { path: '/hgss/poi/:id', name: 'POI ID', component: POIFormPage, style:'hgss'},
  { path: '/hgss/obilaznice', name: 'Obilaznice', component: ObilaznicePage, style:'hgss' },
  { path: '/hgss/izleti-hps', name: 'HPS izleti', component: HPSIzletiPage, style:'hgss' },
  { path: '/hgss/vodici-hps', name: 'HPS vodici', component: HPSVodiciPage, style:'hgss' },
  { path: '/hgss/udruge-hps', name: 'HPS udruge', component: PlaninarskeUdrugePage, style:'hgss' },
  { path: '/hgss/izleti-reg', name: 'REG USER izleti', component: RegisteredUserIzletiPage, style:'hgss' },
  { path: "/hgss", name: "Home", component: HGSSMapPage, style:'hgss'},

  { path: "/hps/profile", name: "Profile", component: ProfilePage, style:'hps'},
  { path: "/hps/map", name: "Map", component: HPSMapPage, style:'hps'},
	{ path: "/hps/users", name: "Map", component: UsersPage, style:'hps'},
  { path: "/hps/poi", name: "POI", component: POIPage, style:'hps'},
  { path: "/hps/staze", name: "Staze", component: StazePage, style:'hps'},
  { path: "/hps/komentari", name: "Komentari", component: CommentsPage, style:'hps'},
  { path: '/hps/poi/:id', name: 'POI ID', component: POIFormPage, style:'hps'},
  { path: '/hps/obilaznice', name: 'Obilaznice', component: ObilaznicePage, style:'hps' },
  { path: '/hps/planinarske-udruge', name: 'Planinarske Udruge', component: PlaninarskeUdrugePage, style:'hps' },
  { path: '/hps/izleti-moji', name: 'Moji izleti', component: VodicIzletiPage, style:'hps' },
  { path: '/hps/izleti-udruge', name: 'Izleti udruge', component: UdrugaIzletiPage, style:'hps' },
  { path: '/hps/vodici-udruge', name: 'Vodici udruge', component: UdrugaVodiciPage, style:'hps' },
  { path: '/hps/izleti-spv', name: 'Izleti SPV', component: SPVIzletiPage, style:'hps' },
  { path: '/hps/vodici-spv', name: 'Vodici SPV', component: SPVVodiciPage, style:'hps' },
  { path: '/hps/izleti-hps', name: 'HPS izleti', component: HPSIzletiPage, style:'hps' },
  { path: '/hps/vodici-hps', name: 'HPS vodici', component: HPSVodiciPage, style:'hps' },
  { path: '/hps/izleti-reg', name: 'REG USER izleti', component: RegisteredUserIzletiPage, style:'hps' },
  { path: "/hps/izleti-stats", name: "Statistika o izletima", component: HpsStatistikaPage, style:'hps' },
  { path: "/hps", name: "Home", component: HPSMapPage, style:'hps'},

  { path: "/reg/profile", name: "Profile", component: ProfilePage, style:'reg'},
  { path: "/reg/map", name: "Map", component: RegUserMapMapge, style:'reg'},
  { path: '/reg/izleti-moji', name: 'Moji izleti', component: MyIzletiPage, style:'reg' },
	{ path: "/reg", name: "Home", component: RegUserMapMapge, style:'reg'},
];

export default privateRoutes
